import { ActionReducerMap } from '@ngrx/store';
import { RouterStateUrl } from './router/router-serializer';
import { authFeature, AuthState } from './auth/auth.reducer';
import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { settingsFeature, SettingsState } from './settings/settings.reducer';
import { metadataFeature, MetadataState } from '@rillion/store/metadata/metadata.reducer';

export interface RootState {
  [authFeature.name]: AuthState;
  [metadataFeature.name]: MetadataState;
  [settingsFeature.name]: SettingsState;
  router: RouterReducerState<RouterStateUrl>;
}

export const reducers: ActionReducerMap<RootState> = {
  [authFeature.name]: authFeature.reducer,
  [metadataFeature.name]: metadataFeature.reducer,
  [settingsFeature.name]: settingsFeature.reducer,
  router: routerReducer,
};
